export default __webpack_public_path__ + "static/planning-development-accomplishment-5-d54b61e8f8799263680b052f9a5758f1.webp";